var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"width":''+_vm.imagew,"src":_vm.imageUrl,"alt":""}}),_vm._t("default",function(){return [_c('div',{staticStyle:{"margin-top":"30px","margin-bottom":"30px","color":"#999999","font-size":"14px","line-height":"14px"}},[_vm._v(" "+_vm._s(_vm.emptyText)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }